import React, { useCallback, useRef, useState } from "react";
import { useRecordContext, useNotify } from "react-admin";
import { Button } from "@mui/material";
import { reportsRequests } from "api/reportsApi";
import dataProvider from "server/dataProvider";
import { download } from "server/download";
import { settings } from "app";
import FormModal from "server/components/Modals/FormModal";
import { REPORT_NAMES, FILE_EXTENSIONS } from "./reports/_data";
import CandidateCampaignExamAttendance from "./reports/CandidateCampaignExamAttendance";
import CandidateCampaignAllExamsResults from "./reports/CandidateCampaignAllExamsResults";
import CandidateCampaignExamResults from "./reports/CandidateCampaignExamResults";
import CandidateCampaignExamsRoomCapacities from "./reports/CandidateCampaignExamsRoomCapacities";
import CandidateCampaignExamStatistic from "./reports/CandidateCampaignExamStatistic";
import CandidateInfoLog from "./reports/CandidateInfoLog";
import SuccessfulPayments from "./reports/SuccessfulPayments";
import OnlineSales from "./reports/OnlineSales";
import RegularCampaignCandidates from "./reports/RegularCampaignCandidates";
import PaidCampaignCandidates from "./reports/PaidCampaignCandidates";
import ForeignerCampaignCandidates from "./reports/ForeignerCampaignCandidates";
import CandidatesNotAccessedProfile from "./reports/CandidatesNotAccessedProfile";
import CoursesCampaignCandidates from "./reports/CoursesCampaignCandidates";
import DownloadIcon from "@mui/icons-material/Download";
import StudentAverageGradeBySemesters from "./reports/StudentAverageGradeBySemesters";
import StudentAverageGradeByCourses from "./reports/StudentAverageGradeByCourses";
import LeftQuitDismissedStudents from "./reports/LeftQuitDismissedStudents";
import GraduatedStudents from "./reports/GraduatedStudents";
import GradeDistributionByCourse from "./reports/GradeDistributionByCourse";
import GradeDistributionSummary from "./reports/GradeDistributionSummary";
import StudentsByCourseAndGroup from "./reports/StudentsByCourseAndGroup";
import ExtendedStudentsByCourseAndGroup from "./reports/ExtendedStudentsByCourseAndGroup";
import StudentAverageSuccess from "./reports/StudentAverageSuccess";
import AllStudentsAcademicData from "./reports/AllStudentsAcademicData";
import StudentsByStatusAndCourse from "./reports/StudentsByStatusAndCourse";
import UnpaidSemesterFees from "./reports/UnpaidSemesterFees";
import BirthYearDistributionByCourse from "./reports/BirthYearDistributionByCourse";
import GenderDistributionByCourse from "./reports/GenderDistributionByCourse";
import BirthCountryDistributionByCourse from "./reports/BirthCountryDistributionByCourse";
import StudentEnrollmentYear from "./reports/StudentEnrollmentYear";
import StudentGraduationYear from "./reports/StudentGraduationYear";
import GetStudentsSemesterFees from "./reports/GetStudentsSemesterFees";
import SessionExamSchedule from "./reports/SessionExamSchedule";
import StateExamSchedule from "./reports/StateExamSchedule";
import StudentsWithoutDisciplineAttestation from "./reports/StudentsWithoutDisciplineAttestation";
import DentalDisciplinesAverageGrades from "./reports/DentalDisciplinesAverageGrades";
import DentalDisciplinesSessionExamsDetail from "./reports/DentalDisciplinesSessionExamsDetail";
import SessionStartUnpassedExamsCount from "./reports/SessionStartUnpassedExamsCount";
import SessionFinalResult from "./reports/SessionFinalResult";
import UnpassedExams from "./reports/UnpassedExams";
import SessionStartAnalysis from "./reports/SessionStartAnalysis";
import ScholarshipAverageGrade from "./reports/ScholarshipAverageGrade";
import StudentsByZvo from "./reports/StudentsByZvo";
import DisciplineSessionExamSuccessRate from "./reports/DisciplineSessionExamSuccessRate";
import InterruptedStudentsWithUnpassedExams from "./reports/InterruptedStudentsWithUnpassedExams";
import StudentsCandidateScore from "./reports/StudentsCandidateScore";
import StudentsBirthPlace from "./reports/StudentsBirthPlace";
import StudentsPermanentAddress from "./reports/StudentsPermanentAddress";
import HealthInsurance from "./reports/HealthInsurance";
import MissingHealthInsuranceDialog from "./reports/MissingHealthInsuranceDialog";
import SummaryOfStudentCountsByStatus from "./reports/SummaryOfStudentCountsByStatus";
import StudentsWithUnpassedExams from "./reports/StudentsWithUnpassedExams";

// Register: report name -> form with parameters + extend for downloaded file.
// Adding new report = new entry here (+ corresponding form in ./reports).
const REPORT_FORMS = {
  [REPORT_NAMES.CandidateCampaignExamAttendance]: {
    Form: CandidateCampaignExamAttendance,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CandidateCampaignAllExamsResults]: {
    Form: CandidateCampaignAllExamsResults,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CandidateCampaignExamResults]: {
    Form: CandidateCampaignExamResults,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CandidateCampaignExamsRoomCapacities]: {
    Form: CandidateCampaignExamsRoomCapacities,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CandidateCampaignExamStatistic]: {
    Form: CandidateCampaignExamStatistic,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CandidateInfoLog]: {
    Form: CandidateInfoLog,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CandidatesNotAccessedProfile]: {
    Form: CandidatesNotAccessedProfile,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.RegularCampaignCandidates]: {
    Form: RegularCampaignCandidates,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.PaidCampaignCandidates]: {
    Form: PaidCampaignCandidates,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.ForeignerCampaignCandidates]: {
    Form: ForeignerCampaignCandidates,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.CoursesCampaignCandidates]: {
    Form: CoursesCampaignCandidates,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.SuccessfulPayments]: {
    Form: SuccessfulPayments,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.OnlineSales]: {
    Form: OnlineSales,
    fileExtension: FILE_EXTENSIONS.Xml,
  },
  [REPORT_NAMES.AllStudentsAcademicData]: {
    Form: AllStudentsAcademicData,
    sendToEmail: true,
    endpoint: reportsRequests.sendMailAcademicDataReport(),
  },
  [REPORT_NAMES.StudentAverageGradeBySemesters]: {
    Form: StudentAverageGradeBySemesters,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentAverageGradeByCourses]: {
    Form: StudentAverageGradeByCourses,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.LeftQuitDismissedStudents]: {
    Form: LeftQuitDismissedStudents,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.GraduatedStudents]: {
    Form: GraduatedStudents,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.GradeDistributionByCourse]: {
    Form: GradeDistributionByCourse,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.GradeDistributionSummary]: {
    Form: GradeDistributionSummary,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsByCourseAndGroup]: {
    Form: StudentsByCourseAndGroup,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.ExtendedStudentsByCourseAndGroup]: {
    Form: ExtendedStudentsByCourseAndGroup,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentAverageSuccess]: {
    Form: StudentAverageSuccess,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsByStatusAndCourse]: {
    Form: StudentsByStatusAndCourse,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.UnpaidSemesterFees]: {
    Form: UnpaidSemesterFees,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.BirthYearDistributionByCourse]: {
    Form: BirthYearDistributionByCourse,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.GenderDistributionByCourse]: {
    Form: GenderDistributionByCourse,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.BirthCountryDistributionByCourse]: {
    Form: BirthCountryDistributionByCourse,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentEnrollmentYear]: {
    Form: StudentEnrollmentYear,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentGraduationYear]: {
    Form: StudentGraduationYear,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.GetStudentsSemesterFees]: {
    Form: GetStudentsSemesterFees,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.SessionExamSchedule]: {
    Form: SessionExamSchedule,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StateExamSchedule]: {
    Form: StateExamSchedule,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsWithoutDisciplineAttestation]: {
    Form: StudentsWithoutDisciplineAttestation,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.DentalDisciplinesAverageGrades]: {
    Form: DentalDisciplinesAverageGrades,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.DentalDisciplinesSessionExamsDetail]: {
    Form: DentalDisciplinesSessionExamsDetail,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.SessionStartUnpassedExamsCount]: {
    Form: SessionStartUnpassedExamsCount,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.SessionFinalResult]: {
    Form: SessionFinalResult,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.UnpassedExams]: {
    Form: UnpassedExams,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.SessionStartAnalysis]: {
    Form: SessionStartAnalysis,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.ScholarshipAverageGrade]: {
    Form: ScholarshipAverageGrade,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsByZvo]: {
    Form: StudentsByZvo,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.DisciplineSessionExamSuccessRate]: {
    Form: DisciplineSessionExamSuccessRate,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.InterruptedStudentsWithUnpassedExams]: {
    Form: InterruptedStudentsWithUnpassedExams,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsCandidateScore]: {
    Form: StudentsCandidateScore,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsBirthPlace]: {
    Form: StudentsBirthPlace,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsPermanentAddress]: {
    Form: StudentsPermanentAddress,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.HealthInsurance]: {
    Form: HealthInsurance,
    fileExtension: FILE_EXTENSIONS.Txt,
    // Backend error code -> dialog shown instead of the default error toast.
    errorDialogs: {
      EC_MissingHealthInsuranceConfig: MissingHealthInsuranceDialog,
    },
  },
  [REPORT_NAMES.SummaryOfStudentCountsByStatus]: {
    Form: SummaryOfStudentCountsByStatus,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
  [REPORT_NAMES.StudentsWithUnpassedExams]: {
    Form: StudentsWithUnpassedExams,
    fileExtension: FILE_EXTENSIONS.Excel,
  },
};

const isEmptyParam = value => value == null || value === "" || (Array.isArray(value) && value.length === 0);

const ExecuteReport = props => {
  const record = useRecordContext(props);
  const notify = useNotify();

  const paramsRef = useRef({});
  const [errorDialogCode, setErrorDialogCode] = useState(null);

  const handleParamChange = useCallback((paramName, paramValue) => {
    paramsRef.current[paramName] = paramValue;
  }, []);

  const config = REPORT_FORMS[record?.name];

  const handleConfirm = async () => {
    // Params without a value (null, undefined, "", []) are left out of the query - URLSearchParams would
    // otherwise send them as "null" / "undefined" / an empty string.
    const params = Object.entries(paramsRef.current).filter(([, value]) => !isEmptyParam(value));
    const qParams = new URLSearchParams(params);

    try {
      await download(
        `${settings.gatewayApi}/${reportsRequests.executeReport(record.name)}?${qParams.toString()}`,
        `report_${record.name}_${new Date().toISOString()}.${config.fileExtension}`,
        "GET",
        null,
        true,
      );
    } catch (err) {
      const errorCode = err?.errorCode ?? err?.ErrorCode;
      if (!config.errorDialogs?.[errorCode]) throw err; // FormModal notifies and stays open

      setErrorDialogCode(errorCode);
      return false; // keep the parameters modal open behind the dialog
    }
  };

  const handleSendToEmail = async () => {
    await dataProvider.customRequest(config.endpoint, { ...paramsRef.current }, "POST");
    notify("Справката ще бъде изпратена на вашия имейл!", { type: "success" });
  };

  if (!config) {
    return (
      <Button
        startIcon={<DownloadIcon />}
        onClick={() => notify("Неимплементирана справка!", { type: "warning" })}
      >
        Изтегли
      </Button>
    );
  }

  const ReportForm = config.Form;
  const ErrorDialog = config.errorDialogs?.[errorDialogCode];

  return (
    <>
      {ErrorDialog && (
        <ErrorDialog
          open
          onClose={() => setErrorDialogCode(null)}
        />
      )}
      <FormModal
        titleContent={record?.displayName || "Параметри на Справка"}
        saveTitle="Изпълни"
        closeTitle="Затвори"
        onOpen={() => {
          paramsRef.current = {};
        }}
        onConfirm={config.sendToEmail ? handleSendToEmail : handleConfirm}
        triggerButton={<Button startIcon={<DownloadIcon />}>Изтегли</Button>}
      >
        <ReportForm handleParamChange={handleParamChange} />
      </FormModal>
    </>
  );
};

export default ExecuteReport;
